<script setup lang="ts">
import { useHomeSections } from '~/composables/apostatudo/use-home-sections';

const title = computed(() => {
  return `${appName()} 🍀 Cassino e Apostas Online | Apostas Esportivas`;
});

const description = computed(() => {
  return `${appName()} — apostas esportivas e jogos online autorizados. Plataforma segura com saque rápido. 18+ | Jogue com responsabilidade.`;
});

useSeo({
  title: title.value,
  description: description.value,
});

const { isHomeAsSportbookEnabled } = useFeatureFlagsNew();

const { fetchHomeSections, hasItems, hasCategories } = useHomeSections();

const isHomeReady = computed(() => hasItems.value || hasCategories.value);
const apiCheckDone = ref(false);

onMounted(async () => {
  if (isHomeAsSportbookEnabled.value) {
    return;
  }

  await fetchHomeSections();
  apiCheckDone.value = true;
});
</script>

<template>
  <template v-if="isHomeAsSportbookEnabled">
    <PagesSports />
  </template>

  <template v-else>
    <PagesHomeSkeleton v-if="!apiCheckDone" />

    <PagesHomeV2 v-else-if="isHomeReady" />

    <PagesHome v-else />

    <ApTitleHome />
  </template>
</template>
